import setFaq from './pages/faq';


import setTabs from './pages/abas';
//addImports

import setTopBar from "../components/topBar";
import setAjudaNav from './pages/ajuda';

const Page = {
  init: function () {
    var _this = this;

    setTopBar();

    setFaq()
		
		
		setTabs();
    
    setAjudaNav();
		//calls

  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init()
})
